// Console counter: handover, return, customers, credits, invoices, refunds.
// Keys are the Arabic source strings (what the Arabic UI shows); values are English.
// Strings that already exist in the prototype catalog (en.ts) need no entry here.
export const consoleCounterEn: Readonly<Record<string, string>> = {
  // Pick lists and shared
  'عرض المزيد': 'Show more',
  'عرض الكل': 'Show all',
  منتهي: 'Expired',
  متأخرة: 'Overdue',
  'اليوم والمتأخرة': 'Today and overdue',
  القادمة: 'Upcoming',
  'فتح في نافذة جديدة': 'Open in a new tab',
  'فتح ملف الـ PDF': 'Open the PDF',
  عرض: 'View',
  'هذا الحقل مطلوب': 'This field is required',
  'القيمة غير صحيحة': 'This value is not valid',
  'النص قصير جداً': 'This is too short',
  ملاحظة: 'Note',
  وصف: 'Description',
  رسوم: 'Fee',
  الرقم: 'Number',
  على: 'on',
  منذ: 'Since',
  مفتوحة: 'open',
  مختلف: 'different',
  'استعدنا ما أدخلته سابقاً لهذا الحجز على هذا الجهاز.':
    'We restored what you entered earlier for this booking on this device.',

  // Handover
  'لا يمكن تسليم هذا الحجز في حالته الحالية.': 'This booking cannot be handed over in its current status.',
  'تم تسليم السيارة': 'Car handed over',
  'سُلّمت السيارة للزبون': 'The car was handed over',
  'تسليم حجز آخر': 'Hand over another booking',
  'تسليم Tesla {model}': 'Hand over Tesla {model}',
  'المبالغ مخفية عن حسابك. إن بقي على الزبون مبلغ فلن يقبل النظام التسليم منك، ويكمله زميل يرى المبالغ.':
    "Amounts are hidden for your account. If the customer still owes anything, the system won't accept the handover from you; a colleague who can see amounts completes it.",
  'على الزبون مبلغ مستحق والمبالغ مخفية عن حسابك، فلا يمكنك تحصيله. اطلب من زميل يرى المبالغ إكمال التسليم.':
    'The customer owes an amount that is hidden for your account, so you cannot collect it. Ask a colleague who can see amounts to complete the handover.',
  'تحصيل المبلغ يحتاج صلاحية تسجيل المدفوعات. اطلب من زميل لديه الصلاحية إكمال التسليم.':
    'Taking the payment needs the record-payments permission. Ask a colleague who has it to complete the handover.',
  'استلمت {amount} نقداً': 'Received {amount} in cash',
  'استلمت {amount} عبر POS': 'Received {amount} by POS',
  'أدخل نسبة الشحن': 'Enter the charge level',
  'الشروط تنص على تسليم السيارة بشحن {min}% على الأقل':
    'The terms require handing the car over with at least {min}% charge',
  'سبب التسليم بشحن أقل (يظهر للمالك)': 'Reason for handing over with less charge (shown to the owner)',
  'اكتب السبب': 'Write the reason',
  'لا يمكن التسليم قبل موعد الاستلام': 'The car cannot be handed over before the pickup time',
  'التسليم متاح من يوم الاستلام · {date}': 'Handover opens on the pickup day · {date}',
  'السيارة مطلوبة لحجز آخر أو صيانة قبل موعد هذا الاستلام. سلّمها في موعدها · {when}':
    'Another booking or maintenance needs the car before this pickup. Hand it over at its time · {when}',
  'لم يحن موعد التسليم بعد': 'Not time to hand over yet',
  'مرفوعة في المحل': 'Uploaded at the shop',
  'مرفوعة أونلاين': 'Uploaded online',
  'مع الحجز': 'with the booking',
  'أُرسلت مع الحجز': 'Sent with the booking',
  'حُجز من الموقع دون تسجيل دخول، فلم تتغير بيانات ملف الزبون. قارن ما أُدخل مع الملف والأصل.':
    "Booked on the website without signing in, so the customer's profile was not changed. Compare what was entered with the profile and the originals.",
  'في ملف الزبون': 'On the profile',
  'أُدخل مع الحجز': 'Entered with the booking',
  'يطابق الملف': 'Matches the profile',
  'لا يطابق الملف': "Doesn't match the profile",
  'تجاوز حد الشحن': 'Battery override',
  'المبلغ المحصّل': 'Amount collected',

  // Return
  'استلام Tesla {model}': 'Return of Tesla {model}',
  // The prototype catalog says "After pickup"; on the return screen it is the car's next state.
  'بعد الاستلام': 'After the return',
  'انتظر اكتمال رفع الصور': 'Wait for the photos to finish uploading',
  'على الزبون مبلغ مستحق والمبالغ مخفية عن حسابك، فلا يمكنك تحصيله. اطلب من زميل يرى المبالغ إكمال الاستلام.':
    'The customer owes an amount that is hidden for your account, so you cannot collect it. Ask a colleague who can see amounts to complete the return.',
  'لم تصدر الفاتورة النهائية بعد.': 'The final invoice is not out yet.',
  'تحقق مرة أخرى': 'Check again',
  'لا يمكن استلام هذا الحجز في حالته الحالية.': 'This booking cannot be returned in its current status.',
  'تم استلام السيارة': 'Car returned',
  'استُلمت السيارة': 'The car is back',
  'استلام سيارة أخرى': 'Receive another car',
  'نسبة الشحن (خرجت بـ {pct}%)': 'Charge level (left with {pct}%)',
  'حرّك المؤشر إلى نسبة الشحن الحالية': 'Move the slider to the current charge level',
  'ناقصة أو تالفة': 'Missing or damaged',
  'ما المشكلة؟': "What's wrong?",
  النظافة: 'Cleanliness',
  'وقت العودة': 'Return time',
  'للمالك فقط · يُسجَّل في السجل': 'Owner only · recorded in the log',
  'وقت عودة السيارة (بتوقيت مسقط)': 'When the car came back (Muscat time)',
  'يُحسب التأخير من هذا الوقت بدلاً من الآن.': 'Lateness is counted from this time instead of now.',
  'اتركه فارغاً لاستخدام الوقت الحالي.': 'Leave it empty to use the current time.',
  'استخدم الوقت الحالي': 'Use the current time',
  'تحصيل المبلغ يحتاج صلاحية تسجيل المدفوعات. اطلب من زميل لديه الصلاحية إكمال الاستلام.':
    'Taking the payment needs the record-payments permission. Ask a colleague who has it to complete the return.',
  'افحص كل الإضافات': 'Check every add-on',
  'أكّد استلام المبلغ': 'Confirm you received the amount',
  'جارٍ حساب المستحق…': 'Working out what is due…',
  'يحتاج صلاحية تسجيل المدفوعات': 'Needs the record-payments permission',
  'أدخل العداد لحساب المستحق.': 'Enter the odometer to work out what is due.',
  'رسوم بالساعة': 'hourly fee',
  'بالساعة بحد أقصى سعر يوم': 'hourly, capped at a day',
  'يوم إضافي': 'an extra day',
  'ضمن فترة السماح': 'within the grace period',
  'بدون رسوم تأخير': 'no late fee',
  'في الموعد': 'On time',
  'إضافات ناقصة أو تالفة': 'Missing or damaged add-ons',
  'رسوم التنظيف': 'Cleaning fee',
  'الخدوش والأضرار': 'Scratches and damage',
  'المتبقي من الحجز': 'Booking balance',
  'المستحق الآن': 'Due now',
  'لا شيء مستحق': 'Nothing due',
  'موضع الخدش': 'Scratch position',
  'موضع الخدش {n}': 'Position of scratch {n}',
  'حذف الخدش {n}': 'Remove scratch {n}',
  'رسوم الضرر (ر.ع)': 'Damage fee (OMR)',
  'تغيير الصورة': 'Change photo',
  'صورة الضرر': 'Damage photo',
  'رفع الصورة': 'Uploading the photo',
  'صورة مرفوعة': 'Photo uploaded',
  'رسوم التأخير': 'Late fee',
  'السيارة الآن': 'The car now',
  'الفاتورة النهائية': 'Final invoice',
  'تُصدر الفاتورة النهائية تلقائياً…': 'The final invoice is being issued…',

  // Payments and refunds
  الإيجار: 'Rent',
  'المبلغ المتبقي': 'Balance',
  'رسوم تأخير': 'Late fee',
  أضرار: 'Damage',
  تنظيف: 'Cleaning',
  تسوية: 'Adjustment',
  بطاقة: 'Card',
  'جهاز POS': 'POS',
  'قيد المعالجة': 'Processing',
  ناجحة: 'Succeeded',
  فشلت: 'Failed',
  ملغاة: 'Cancelled',
  مستردة: 'Refunded',
  'قيد التنفيذ': 'In progress',
  'تم الاسترداد': 'Refunded',
  'فشل الاسترداد': 'Refund failed',
  'إلى البطاقة': 'Back to the card',
  'نقداً عند المكتب': 'Cash at the desk',
  'إلى رصيد الزبون': "To the customer's credit",
  'لا توجد دفعات بعد': 'No payments yet',
  'تسجيل دفعة عند المكتب': 'Record a desk payment',
  المسترد: 'Refunded',
  استرداد: 'Refund',
  'إعادة محاولة الاسترداد': 'Refund retried',
  'ما زال الاسترداد معلقاً، وسيُعاد تلقائياً':
    'The refund is still pending and will be retried automatically',
  'لم تقبل بوابة الدفع الاسترداد بعد، ويُعاد تلقائياً.':
    "The payment service hasn't taken the refund yet; it is retried automatically.",
  المحاولات: 'Attempts',
  'المحاولة التالية': 'Next attempt',
  'آخر رد من البوابة': 'Last answer from the gateway',
  'إعادة المحاولة الآن': 'Retry now',
  'حُوّل هذا الحجز إلى رصيد، والرصيد أعاد للزبون هذا المبلغ.':
    'This booking was converted to credit, which already gave the customer this money.',
  'يمكن استرداد {amount} فقط.': 'Only {amount} can be refunded.',
  'لا يمكن استرداد شيء من هذه الدفعة.': 'Nothing can be refunded from this payment.',
  'استرداد آخر لهذه الدفعة قيد التنفيذ. انتظر حتى يكتمل ثم حاول مجدداً.':
    'Another refund of this payment is still being processed. Wait until it completes, then try again.',
  'سُجّل الاسترداد، وبوابة الدفع ستعالجه لاحقاً':
    'Refund recorded; the payment service will process it later',
  'أكبر من المتبقي ({amount})': 'More than what is left ({amount})',
  'طريقة الاسترداد': 'Refund method',
  'استرداد البطاقة يكون للدفعة كاملة': 'Card refunds return the whole payment',
  'يعود المبلغ كاملاً إلى الرصيد': 'The whole amount goes back to credit',
  'حتى {amount}': 'Up to {amount}',
  'يُحفظ مع الاسترداد وفي سجل الأنشطة': 'Kept with the refund and in the activity log',
  'تأكيد الاسترداد': 'Confirm refund',
  'سُجّلت الدفعة': 'Payment recorded',
  'المبلغ أكبر من المتبقي على الحجز': 'The amount is more than the balance due',
  'نوع الدفعة': 'Payment type',
  'بطاقة على جهاز المكتب': 'Card on the desk terminal',
  'رقم إيصال الجهاز': 'Terminal receipt number',
  'تسجيل الدفعة': 'Record payment',

  // Invoices
  إيصال: 'Receipt',
  'إشعار دائن': 'Credit note',
  'لا تملك صلاحية عرض الفواتير': "You don't have permission to see invoices",
  'إصدار الفاتورة النهائية': 'Issue the final invoice',
  'إصدار إيصال الحجز': 'Issue a booking receipt',
  'لم يصدر أي مستند لهذا الحجز بعد': 'No document has been issued for this booking yet',
  'تصدر مرة واحدة بعد الاستلام': 'Issued once, after the return',
  'يُرقَّم إيصال جديد فقط إذا تغيّرت المبالغ أو الدفعات':
    'A new receipt number is used only when amounts or payments changed',
  'تحويل الحجز إلى رصيد': 'Booking converted to credit',
  'صدر الإشعار الدائن {number}': 'Credit note {number} issued',
  'إشعار دائن على': 'Credit note on',
  'قيمة الإشعار': 'Credit note amount',
  'كل المتبقي من المستند': 'Everything not yet credited',
  'مبلغ محدد': 'A specific amount',
  'إصدار الإشعار': 'Issue credit note',
  'الفواتير والإيصالات': 'Invoices and receipts',
  فواتير: 'Invoices',
  إيصالات: 'Receipts',
  'إشعارات دائنة': 'Credit notes',
  'تاريخ النهاية قبل البداية': 'The end date is before the start date',
  'لا توجد مستندات بهذه التصفية': 'No documents match these filters',

  // Customers
  الزبائن: 'Customers',
  'ابحث بالاسم أو رقم الهاتف': 'Search by name or phone number',
  'بحث عن زبون': 'Search customers',
  'الاسم أو الهاتف…': 'Name or phone…',
  'لديهم رصيد': 'With credit',
  'لا يوجد زبائن مطابقون': 'No matching customers',
  'لا يوجد زبائن بعد': 'No customers yet',
  'الهوية مسجلة': 'ID on file',
  'بدون هوية': 'No ID',
  'كل الزبائن': 'All customers',
  'سجل الرصيد': 'Credit history',
  الرصيد: 'Credit',
  'آخر حجز': 'Last booking',
  'زبون منذ': 'Customer since',
  'أقسام الزبون': 'Customer sections',
  'لا تملك صلاحية عرض تفاصيل هذا الزبون': "You don't have permission to see this customer's details",
  'بيانات الزبون': 'Customer details',
  مسجّل: 'On file',
  'غير مسجّل': 'Not on file',
  اللغة: 'Language',
  'الرسائل التسويقية': 'Marketing messages',
  موافق: 'Opted in',
  'غير موافق': 'Opted out',
  'لا توجد حجوزات لهذا الزبون': 'No bookings for this customer',
  'صورة ضرر': 'Damage photo',
  'لا توجد مستندات': 'No documents',
  'أُزيل وفق قاعدة مدة الحفظ': 'Removed under the retention rule',
  'لم يكتمل الرفع': 'Upload not finished',
  'استخدام في حجز': 'Used for a booking',
  'رصيد يدوي': 'Manual credit',
  'عكس قيد': 'Reversal',
  'الرصيد الحالي': 'Current balance',
  'لا توجد حركات على الرصيد': 'No credit movements',
  'انتهاء صلاحية الرصيد': 'Credit expired',

  // Credits page
  'أُضيف الرصيد': 'Credit added',
  'سياسة الإيجار: لا إلغاء. التحويل إلى رصيد قبل {h} ساعة على الأقل من الاستلام.':
    'Rental policy: no cancellations. Conversion to credit at least {h} hours before pickup.',
  'اعتُمد الطلب وأُضيف الرصيد': 'Request approved and credit added',
  'رُفض الطلب': 'Request rejected',
  'يُلغى الحجز وتتحرر السيارة، ويُضاف {amount} إلى رصيد الزبون على الرقم':
    "The booking is cancelled, the car is freed, and {amount} is added to the customer's credit on",
  'خارج المهلة: الاعتماد تجاوز للسياسة وسيُسجَّل.':
    'Outside the window: approving overrides the policy and is logged.',
  'سبب الرفض (يصل للزبون)': 'Reason for rejecting (sent to the customer)',
  'تأكيد الرفض': 'Confirm rejection',
  'مطلوب إن لم يكن الرقم مسجلاً': "Required if the number isn't registered",
  'الاسم مطلوب لزبون جديد': 'A name is required for a new customer',

  // Photos and documents taken at the desk
  'صور حالة السيارة': 'Photos of the car',
  'صور السيارة عند الخروج': 'Photos of the car as it leaves',
  'صوّر الجوانب الأربعة وأي خدش موجود، تُحفظ مع الحجز.':
    'Photograph all four sides and any existing scratch; they are kept with the booking.',
  'صور السيارة عند العودة': 'Photos of the car as it comes back',
  'صور عامة لحالة السيارة؛ صورة كل خدش تُرفق مع الخدش نفسه.':
    "General photos of the car's condition; each scratch's photo goes with that scratch.",
  'إضافة صور': 'Add photos',
  'حذف الصورة {n}': 'Remove photo {n}',
  'رفع نسخة جديدة من البطاقة أو الرخصة': 'Upload a new copy of the ID card or licence',
  'مستندات رُفعت عند التسليم': 'Documents uploaded at handover',
};
